<nav class="navbar navbar-expand-lg"  style="background-color:#dd0a0a;">
    <div class="container-fluid">
      <a class="navbar-brand" href="https://www.spineatools">
         <img [src]="AssetbasePath + '/Content/MainImages/SpineaHeader.png'" 
      alt="Logo" 
      width="315"
      height="60"
     class="d-inline-block align-text-top navbar-dark">
      </a>

      <button class="navbar-toggler ms-auto" type="button" data-bs-toggle="collapse" data-bs-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
    </button>
        <div class="collapse navbar-collapse" id="navbarResponsive">
            <ul class="navbar-nav ms-auto">
                <li class="nav-item">
                    <a class="nav-link" href="https://www.spinea.com/" target="_blank" style="color:white">Spinea</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="https://www.spineatools" target="_blank" style="color:white">Spinea Tools</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="https://www.spinea.com/en/about%20us/contact" target="_blank" style="color:white">Contact</a>
                </li>
            </ul>
        </div>  
    </div>
    
  </nav>